import { ModalContext } from "@/lib/main";
import { type ReactNode, useEffect, useRef, useState } from "react";

const ModalProvider = ({ children }: { children: ReactNode }) => {
  const [content, setContent] = useState<ReactNode>(null);
  const [showModal, setShowModal] = useState(false);

  const modalRef = useRef<HTMLDivElement>(null);
  const clearContentTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  const closeModal = () => {
    const wasOpen = Boolean(modalRef.current);

    if (clearContentTimeoutRef.current) {
      clearTimeout(clearContentTimeoutRef.current);
      clearContentTimeoutRef.current = null;
    }

    setShowModal(false);

    // * wait for animation only if modal was actually open
    if (wasOpen) {
      clearContentTimeoutRef.current = setTimeout(() => {
        setContent(null);
        clearContentTimeoutRef.current = null;
      }, 330);
    } else {
      setContent(null);
    }
  };

  useEffect(() => {
    return () => {
      if (clearContentTimeoutRef.current) {
        clearTimeout(clearContentTimeoutRef.current);
      }
    };
  }, []);

  return (
    <ModalContext.Provider
      value={{
        showModal,
        setShowModal,
        content,
        setContent,
        modalRef,
        closeModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
